import React from "react";
import PropTypes from "prop-types";
import { useNe1 } from "./hooks/useNe1";
import { Ne1EditMode } from "./components/Ne1EditMode";
import { Ne1ViewMode } from "./components/Ne1ViewMode";
import { AccessErrorModal } from "../../../primary";
import { CustomerTabSkeleton } from "../../../common/CustomerTabSkeleton/CustomerTabSkeleton";
import { useLoading } from "../../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../../constants/loadingKeys";
import { CUSTOMER_UPDATE_SUCCESS, UPDATE_FAILURE, SUCCESS_STATUS, ERROR_STATUS } from "../../../../constants";
import styles from "./Ne1.module.scss";

export function Ne1({ customerData }) {
  const hook = useNe1({ customerData });
  const isDetailLoading = useLoading(LOADING_KEYS.GET_CUSTOMER_DETAIL);

  if (isDetailLoading) {
    return (
      <div className={styles.wrapper}>
        <CustomerTabSkeleton />
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      {hook.saveStatus === SUCCESS_STATUS && <div className={`${styles.alert} ${styles.alert_success}`}>{CUSTOMER_UPDATE_SUCCESS}</div>}

      {hook.saveStatus === ERROR_STATUS && <div className={`${styles.alert} ${styles.alert_danger}`}>{UPDATE_FAILURE}</div>}

      {!hook.editable ? (
        <Ne1ViewMode customerData={customerData} onEdit={hook.handleEdit} />
      ) : (
        <Ne1EditMode
          customerData={customerData}
          handleSubmit={hook.handleSubmit}
          doSubmit={hook.doSubmit}
          register={hook.register}
          errors={hook.errors}
          form={hook.form}
          submitErrors={hook.submitErrors}
          onFieldChange={hook.onFieldChange}
          onMultiChange={hook.onMultiChange}
          ne1State={hook.ne1State}
          popupSave={hook.popupSave}
          makeShiftSold={hook.makeShiftSold}
          showConfirmPopup={hook.showConfirmPopup}
          onClickStatus={hook.handleClickStatus}
          onModalOpen={hook.modalOpen}
          onModalClose={hook.modalRefresh}
          onSavePopup={hook.handleSavePopup}
          onCancelPopup={hook.handleCancelPopup}
          onCancel={hook.handleEdit}
          saveLoading={hook.saveLoading}
        />
      )}

      {hook.accessError && <AccessErrorModal />}
    </div>
  );
}

Ne1.propTypes = {
  customerData: PropTypes.object,
};
